import loadable from '@loadable/component';


export default loadable(() => import(/* webpackChunkName: "Wishlist.d" */ './../../layouts/Wishlist'));
